import { render, staticRenderFns } from "./RankingsList.vue?vue&type=template&id=2dacf8ed&"
import script from "./RankingsList.vue?vue&type=script&lang=js&"
export * from "./RankingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports